module.exports = __webpack_public_path__ + "static/img/son4_active.1cb3a431.png";